<!-- Convenios Principal -->
<div>

  <div class="grid">
    <div class="col-12">
      <h1 class="titulo-pagina">{{ 'CONVENIOS.LBL_CONVENIOS' | translate}}</h1>
    </div>
  </div>

  <div>

    <!-- Listado -->

    <div class="grid col-nopad">

      <!-- Botones -->
      <div class="col-6">
        <div class="form-group">
          <button pButton icon="fa fa-plus" label="{{ 'BTN_AGREGAR' | translate}}" type="button" (click)="accionListado(null, 'AGREGAR')"></button>
        </div>
      </div>

      <!-- Búsqueda -->
      <div class="col-6 text-right">
        <div class="form-group">
          <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                 (input)="td.filterGlobal($event.target.value, 'contains')"
                 [(ngModel)]="busqueda">
        </div>
      </div>


    </div>


    <!-- Tabla -->
    <div class="grid col-nopad">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="cargandoTabla" #td
                 [rows]="10" [value]="datosTabla" [paginator]="true"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                  class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.numeroContrato}}</td>
              <td>{{row.nombre}}</td>
              <td>{{row.fechaDesde}}</td>
              <td>{{row.fechaHasta}}</td>
              <td>{{row.nombreOpcionDesembolso}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}"
                          pButton (click)="accionListado(row, 'DETALLE')"></button>
                  <button type="button" class="p-button btn" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}"
                          pButton (click)="accionListado(row, 'EDITAR')"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>


  </div>


</div>
